import { pokeApiAxios } from "./index";
import { GET_TYPE } from "./endpoints";

const getType = async (identifier) => {
  const response = await pokeApiAxios.get(GET_TYPE(identifier));
  return response.data;
};

export { getType };
